export const ErrorCode = Object.freeze({
  UNAUTHORISED: 'UNAUTHORISED',
  AUTH_NOT_AUTHENTICATED: 'AUTH_NOT_AUTHENTICATED',
  DATA_EXISTS: 'DATA_EXISTS',
  DATA_REQUIRED: 'DATA_REQUIRED',
  NOT_FOUND: 'NOT_FOUND',
  BAD_INPUT: 'BAD_INPUT',
  FORBIDDEN: 'FORBIDDEN',
  SERVICE_BUSY: 'SERVICE_BUSY'
})
